import { useState, useCallback, useMemo } from 'react'
import { useTranslation } from '../../../../../shared/hooks/useIntractionTranslate'
import type { SprintEmailContent } from '../../../../../../../pure-js/types/Sprint'
import { buildDefaultEmailContent } from './emailEditorDefaults'

interface UseEmailEditorStateProps {
  initialContent?: SprintEmailContent
}

export function useEmailEditorState({ initialContent }: UseEmailEditorStateProps) {
  const { t } = useTranslation()

  const defaults = useMemo(() => buildDefaultEmailContent(t), [t])

  const [content, setContent] = useState<SprintEmailContent>(() => initialContent || defaults)

  const updateBody = useCallback((body: string) => {
    setContent({ body })
  }, [])

  const resetToDefaults = useCallback(() => {
    setContent(defaults)
  }, [defaults])

  return {
    content,
    updateBody,
    resetToDefaults
  }
}
